const itemDetailsActionsTypes = {
    EDIT_ITEM: "EDIT_ITEM",
    EDIT_ITEM_ERROR: "EDIT_ITEM_ERROR",
    CANCEL_EDIT_ITEM: "CANCEL_EDIT_ITEM",
    CHANGE_NAME: "CHANGE_NAME",
    CHANGE_TITLE: "CHANGE_TITLE",
    CHANGE_DESCRIPTION: "CHANGE_DESCRIPTION",
    CHANGE_PERMISSIONS: "CHANGE_PERMISSIONS",
    SET_VALIDATION_ERRORS: "SET_VALIDATION_ERRORS",
    ITEM_SAVED: "ITEM_SAVED",
    SAVE_ITEM_ERROR: "SAVE_ITEM_ERROR",
    MOVE_ITEM: "MOVE_ITEM",
    MOVE_ITEM_ERROR: "MOVE_ITEM_ERROR",
    CANCEL_MOVE_ITEM: "CANCEL_MOVE_ITEM",
    ITEM_MOVED: "ITEM_MOVED",
};

export default itemDetailsActionsTypes;